<template>
  <div class="index_content">
    <div class="f-row">
      <Breadcrumb
        separator=">"
        class="breadcrumb_zdy"
      >
        当前位置:
        <BreadcrumbItem
          :to="{name: 'WorkBench'}"
          v-if="from_name == 'WorkBench'"
        >工作台Max</BreadcrumbItem>
        <BreadcrumbItem
          :to="{name: 'NewsList'}"
          v-else
        >快讯Live</BreadcrumbItem>
        <BreadcrumbItem>设置关注</BreadcrumbItem>
      </Breadcrumb>
      <div>
        <a href="javascript:history.back(-1)"><i class="iconfont-sm">&#xe661;</i> 返回上一级页面</a>
      </div>
    </div>
    <div class="attention_index clear">
      <div class="attention_sider">
        <div class="attention_list">
          <p class="tle">关注列表</p>
          <ul class="a_list">
            <li :class="{on: all_or_group == 1 && all_select == 'field'}">
              <p @click="haddleAllSelect('field')">
                <i class="iconfont">&#xe63c;</i>
                <span>关注的领域({{attention_count.tag}})</span>
              </p>
            </li>
            <li :class="{on: all_or_group == 1 && all_select == 'comp'}">
              <p @click="haddleAllSelect('comp')">
                <i class="iconfont">&#xe6b9;</i>
                <span>关注的公司({{entity_count.comp}})</span>
              </p>
            </li>
            <li :class="{on: all_or_group == 1 && all_select == 'org'}">
              <p @click="haddleAllSelect('org')">
                <i class="iconfont">&#xe6ba;</i>
                <span>关注的机构({{entity_count.org}})</span>
              </p>
            </li>
            <!-- 自定义分组 -->
            <li v-for="(item,index) in attention.group" :class="{on: s_group_id == item.id}" class="group-li">
              <p>
                <i class="iconfont">&#xe734;</i>
                <span @click="haddleAttentionType(item)">{{item.name}}({{group_num(item.id)}})</span>
              </p>
              <i class="iconfont clear-icon" @click="editGroup(item)">&#xe63d;</i>
              <i class="iconfont" @click="deleteConfirm(item)">&#xe63e;</i>
            </li>
            <!-- 热门主题 -->
            <li v-for="(item,index) in zt_list" :class="{on: zt_group_id == item.id}" class="group-li">
              <p>
                <i class="iconfont">&#xe74a;</i>
                <span @click="haddleZt(item.id)">{{item.name}}({{item.entitys.length}})</span>
              </p>
              <!-- <i class="iconfont clear-icon" @click="editGroup(item)">&#xe63d;</i> -->
              <i class="iconfont" @click="deleteConfirm(item, true)">&#xe63e;</i>
            </li>
            <!-- 值得关注 -->
            <li v-for="item,index in yz_group" :key="index" :class="{on: all_or_group == 3 && yz_group_id == item.id, fir_li: true}">
              <p @click="haddleAttentionDefault(item.id)">
                <i class="iconfont">&#xe735;</i>
                <span>{{item.name}}({{item.org.length + item.comp.length}})</span>
              </p>
            </li>
            <li class="add_atten">
              <a @click="haddleAddAtten"><Icon type="md-add" />添加分组</a>
            </li>
          </ul>
        </div>
      </div>
      <div
        class="attention_content"
        v-if="all_or_group == 1"
      >
        <AttentionFieldAll v-if="all_select == 'field'"></AttentionFieldAll>
        <AttentionCompanyAll v-if="all_select == 'comp'" @showlimit="showLimit"></AttentionCompanyAll>
        <AttentionOrgAll v-if="all_select == 'org'" @showlimit="showLimit"></AttentionOrgAll>
      </div>
      <div
        class="attention_content"
        v-if="all_or_group == 2"
      >
        <div class="attention_content_title">{{s_group_name}}</div>
        <div class="attention_content_nav">
          <Menu
            mode="horizontal"
            theme="light"
            :active-name="select"
            @on-select="haddleSelect"
          >
            <!-- <MenuItem name="field">领域</MenuItem> -->
            <MenuItem name="comp">公司</MenuItem>
            <MenuItem name="org">机构</MenuItem>
          </Menu>
        </div>
        <!-- <AttentionField v-if="select == 'field'" :selGroupId="s_group_id"></AttentionField> -->
        <AttentionCompany v-if="select == 'comp'" @showlimit="showLimit" :selGroupId="s_group_id"></AttentionCompany>
        <AttentionOrg v-if="select == 'org'" @showlimit="showLimit" :selGroupId="s_group_id"></AttentionOrg>
      </div>
      <DefaultGroup
        v-for="item,index in yz_group"
        :key="index"
        :defaultGroupItem="item"
        v-if="all_or_group == 3 && yz_group_id == item.id"
      ></DefaultGroup>
      <AttentionZt
        v-for="item,index in zt_list"
        :key="index"
        :defaultGroupItem="item"
        v-if="all_or_group == 4 && zt_group_id == item.id"
      ></AttentionZt>
      <CreateAttention :createAttentionModal="create_attention"></CreateAttention>
      <Modal
        class="model_zdy"
        width="356"
        v-model="edit_model"
        :mask-closable="false"
      >
        <div slot="header">编辑关注列表</div>
        <div class="model_content">
          <Form
            ref="edit_group"
            :model="edit_group"
            :rules="attention_rules"
            @submit.native.prevent
          >
            <FormItem prop="name">
              <Input
                v-model="edit_group.name"
                placeholder="请输入筛选组名称（最多10个字）"
                @on-enter="editGroupSub"
              ></Input>
            </FormItem>
          </Form>
        </div>
        <div slot="footer">
          <Button
            type="text"
            @click="edit_model = false"
          >取消</Button>
          <Button
            type="primary"
            @click="editGroupSub"
          >确定</Button>
        </div>
      </Modal>
    </div>

    <!-- <div class="how_att" v-show="how_att && how_pic_index != 4 ">
          <div class="how_att_info">
            <div class="one">
              <img :src="$store.state.static_img_url+'pic/f.png'">
              <img :class="{ 'on':how_pic_index >= 2 }" :src="$store.state.static_img_url+'pic/s.png'">
              <img :class="{ 'on':how_pic_index == 3 }" :src="$store.state.static_img_url+'pic/t.png'">
            </div>
            <div class="two">
              <div class="dot">
                <div :class="{ 'on':how_pic_index == 1 }"></div>
                <div :class="{ 'on':how_pic_index == 2 }"></div>
                <div :class="{ 'on':how_pic_index == 3 }"></div>
              </div>
              <p @click="how_pic_index = how_pic_index + 1">{{how_pic_index == 3?'我知道了':'继续了解'}}</p>
            </div>
            <i class="iconfont" @click="how_att = false">&#xe65e;</i>
          </div>
        </div> -->
        <OrgModal ref="org_modal" :imgurl="org_modal_img">
          <p class="p1" slot>{{org_modal_p}}</p>
        </OrgModal>
  </div>
</template>

<script>
import { attention_mixins } from 'js/attention_mixins'
import { attention_entity_mixins } from 'js/attention_entity_mixins'
import CreateAttention from '@/components/CreateAttention.vue'
import { deleteSubscribe, editsubGroup, userEntityCount } from '../../service'
import AttentionField from './components/AttentionField.vue'
import AttentionCompany from './components/AttentionCompany.vue'
import AttentionOrg from './components/AttentionOrg.vue'

import AttentionFieldAll from './components/AttentionFieldAll.vue'
import AttentionCompanyAll from './components/AttentionCompanyAll.vue'
import AttentionOrgAll from './components/AttentionOrgAll.vue'

import DefaultGroup from './components/DefaultGroup.vue'
import AttentionZt from './components/AttentionZt.vue'
import OrgModal from '@/components/OrgModal.vue'

export default {
  name: 'NewsList',
  mixins: [attention_mixins, attention_entity_mixins],
  components: {
    CreateAttention,
    AttentionField, AttentionFieldAll,
    AttentionCompany, AttentionCompanyAll,
    AttentionOrg, AttentionOrgAll,
    DefaultGroup, AttentionZt, OrgModal
  },
  computed: {
    create_g_id() {
      return this.create_attention.id
    },
    create_g_name() {
      return this.create_attention.name
    },
    attention_count() {
      let tag_count = 0, comp_count = 0, org_count = 0
      this.attention.subscribe.map((a) => {
        if (a.sub_type == 20) {
          tag_count++
        }
      })
      return {
        tag: tag_count,
        group: this.attention.group.length
      }
    },
    from_name() {
      return this.$store.state.from_name
    },
    group_num() {
      return function(g_id) {
        let arr = []
        if(this.attention.g_relation) {
          this.attention.g_relation.map((a) => {
            if(a.group_id === g_id) {
              arr.push(a)
            }
          })
        }
        return arr.length
      }
    }
  },
  data() {
    return {
      s_group_id: '',
      s_group_name: '',

      select: 'comp',
      all_select: 'field',

      all_or_group: 1, //1 all    2 group

      yz_group_id: '',
      zt_group_id: '',
      create_attention: {
        model: false,
        id: '',
        name: ''
      },
      edit_model: false,
      edit_group: {
        id: '',
        name: ''
      },
      attention_rules: {
        name: [{ required: true, message: '关注组名不能为空', trigger: 'blur' },
        { type: 'string', max: 10, message: '关注组名长度不能超过10个字', trigger: 'blur' }]
      },

      // how_att: false,
      // how_pic_index: 1,

      entity_count: {
        comp: 0,
        org: 0
      },
    }
  },
  methods: {
    haddleSelect(val) {
      this.select = val
    },
    haddleAllSelect(val) {
      this.all_select = val
      this.all_or_group = 1
      this.s_group_id = ''
      this.zt_group_id = ''
    },
    haddleAttentionType(item) {
      this.s_group_id = item.id
      this.s_group_name = item.name
      this.select = 'comp'
      this.all_or_group = 2
      this.zt_group_id = ''
    },
    haddleZt(data_id) {
      this.all_or_group = 4
      this.zt_group_id = data_id
      this.s_group_id = ''
      this.s_group_name = ''
    },
    haddleAttentionDefault(data_id) {
      this.all_or_group = 3
      this.yz_group_id = data_id
      this.s_group_id = ''
      this.s_group_name = ''
      this.zt_group_id = ''
    },
    haddleAddAtten() {
      if (this.user_key) {
        this.create_attention.model = !this.create_attention.model
      } else {
        this.$Message.error('请先登录！')
      }
    },
    deleteConfirm(item, zt) {
      const _that = this
      layer.confirm('删除后将无法恢复，是否删除', {
        title: false,
        offset: '100px',
        skin: 'layer-custom',
        btn: ['确定', '取消'] //按钮
      }, function () {
        if(zt) {
          _that.delsubscribe({
            user_key: _that.$store.state.user_key,
            subscribe_id: _that.attention.subscribe.find(s => s.sub_type_id == item.id)['id'],
            op_type: 'cancel'
          }, () => {
            _that.refreshZtList()
          })
        } else {
          _that.deleteGroup(item)
        }
        layer.closeAll()
      }, function () {
        layer.closeAll()
      })
    },
    async deleteGroup(item) { // 删除分组
      const del_group = {
        op_type: 'del',
        group_id: item.id,
        user_key: this.user_key
      }
      let res = await deleteSubscribe(del_group, (error) => {
        this.$Message.error('请求错误！')
      })
      if (res.status == 'success') {
        const _that = this
        this.getSubscribeList(function () {
          if (_that.s_group_id == item.id) {
            if (_that.attention.group.length > 0) {
              _that.s_group_id = _that.attention.group[0].id
              _that.s_group_name = _that.attention.group[0].name
            }
          }
          if (_that.attention.group.length == 0) {
            _that.all_select = 'field'
            _that.all_or_group = 1
          }
          _that.$Message.success('删除成功!')
        })
      } else {
        this.$Message.error(res.msg)
      }
    },
    editGroup(item) {
      // console.log(item)
      this.edit_group.name = item.name
      this.edit_group.id = item.id
      this.edit_model = true
    },
    editGroupSub() {
      this.$refs['edit_group'].validate(async (valid) => {
        if (valid) {
          const edit_obj = {
            name: this.edit_group.name,
            id: this.edit_group.id,
            user_key: this.user_key
          }
          let res = await editsubGroup(edit_obj, (error) => {
            this.$Message.error('请求失败！')
          })
          if (res.status == 'success') {
            this.$Message.success('修改成功!')
            this.getSubscribeList()
            this.edit_model = false
          } else {
            this.$Message.error(res.message)
          }
        } else {
          this.$Message.warning('请检查表单是否符合要求!')
        }
      })
    },
    async getEntityCount() {
      let res = await userEntityCount({ user_key: this.user_key }, (error) => {
        this.$Message.error('请求错误！')
      })
      if (res.status == 'success') {
        let item = res.res[0]
        this.entity_count.comp = item.comp ? item.comp : 0
        this.entity_count.org = item.org ? item.org : 0
      } else {
        this.$Message.error(res.msg)
      }
    },
    showLimit(type, cb) { // 传递到子组件（关注限制的弹窗）
      this.addAttentionLimt(type, cb)
    }
  },
  created() {
    if (this.$route.query.active) {
      this.s_group_id = this.$route.query.active
      if (this.attention.group.length > 0) {
        this.s_group_name = this.attention.group.find(a => this.s_group_id == a.id).name
      }
      this.all_or_group = 2
    } else if (this.$route.query.yz_group) {
      this.all_or_group = 3
      this.yz_group_id = this.$route.query.yz_group
    } else if (this.$route.query.type && this.$route.query.select) {
      this.all_select = this.$route.query.select
      this.all_or_group = this.$route.query.type
    } else {
      this.s_group_id = ''
      this.s_group_name = ''
      this.all_or_group = 1
    }
    // if (document.cookie.indexOf('attention_first=true') == -1) {
    //   this.how_att = true
    //   document.cookie='attention_first=true';
    // }
    this.getEntityCount()
    // this.getMeta()
  },
  watch: {
    create_g_id(val) {
      if (val) {
        this.s_group_id = val
        this.s_group_name = this.create_g_name
        this.all_or_group = 2
      }
    },
    attention() {
      this.getEntityCount()
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '~styles/common.stylus'
.index_content
  padding: 16px 0 20px
  .attention_index
    margin-top: 16px
    .attention_list
      p.tle
        commonBgColor(#2A2F42, #FFFAF5)
        font-size: 16px
        commonColor(#E9E9EB, #333333)
        line-height: 50px
        font-weight: 600
        padding-left: 20px
      .a_list
        padding: 0 20px
        commonBgColor(#1f2330, #FFFFFF)
        li
          border-bottom: 1px solid
          commonBorderColor(#40444F, #E9E9E9)
          padding: 16px 0
          &.on
            p
              color: rgba(250, 122, 80, 1) !important
          p
            commonColor(#E9E9EB, #666666)
            display: inline-block
            cursor: pointer
            position relative
            padding-left 20px
            &:hover
              color: rgba(250, 122, 80, 1)
            span
              font-size: 13px
              display: inline-block
              vertical-align: top
            i
              font-size: 13px
              position absolute
              left 0
          &.group-li
            position relative
            padding-right 36px                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           
            > i
              position: absolute
              font-size: 14px
              commonColor(#E9E9EB, #666666)
              cursor: pointer
              right: 0
              top: 17px
              display: none
              &.clear-icon
                right 18px
              &:hover
                color: #FA7A50
            &:hover
              > i
                display: block
          &.add_atten
            border: 0
            a
              border-radius 4px
              display block
              width 100%
              color rgba(250, 122, 80, 1)
              height 34px
              font-size 12px
              commonBgColor(rgba(42, 47, 66, 1), rgba(255, 245, 242, 1))
              display flex
              justify-content center
              align-items center
              &:hover
                background-color rgba(250, 122, 80, 1)
                color rgba(255, 255, 255, 1)
              i
                font-size 12px
                margin-right 4px
  .attention_sider
    width: 208px
    float: left
  .attention_content
    margin-left: 16px
    float: right
    width: 976px
    position relative
    >>> .a-fix
      top: 50px
      left: 0
      right: 0
      bottom: 0
      height: auto
    .ivu-menu-light
      background: transparent
      padding: 30px 0 0
      height: 56px
      border-bottom: 1px solid
      commonBorderColor(#40444F, #E9E9E9)
      &:after
        content: none
      .ivu-menu-item
        commonColor(#BCBDC1, #333333)
        text-align: center
        width: 120px;
        padding: 0 0 12px 0;
        font-size: 14px;
        line-height: 1;
        height: 26px;
        &+li
          margin-left: 16px
        &:hover
          commonColor(#BCBDC1, #333333)
          border-color: transparent
        &.ivu-menu-item-active
          color: rgba(250, 122, 80, 1)
          border-color: rgba(250, 122, 80, 1)

.model_zdy
  & >>> .ivu-modal-header
    padding: 16px
    font-size: 16px
    line-height: 1
  & >>> .ivu-modal-body
    padding: 20px
    .ivu-form
      .ivu-form-item
        margin-bottom: 0
        .ivu-form-item-content
          .ivu-input
            border-color: #DADCE2
            border-radius: 4px
            color: #333
            height: 40px
            font-size: 14px
            padding: 10px
            &::-webkit-input-placeholder
              color: #999
            &:focus
              box-shadow: none
              border-color: rgba(250, 122, 80, 1)
        &.ivu-form-item-error
          .ivu-input
            border-color: #F3494B
  & >>> .ivu-modal-footer
    padding: 0 20px 20px
    border-top: 0
    .ivu-btn
      width: 60px
      height: 32px
      font-size: 14px
      line-height: 1
      margin-left: 10px
      &:focus
        box-shadow: none
    .ivu-btn-text
      color: #666
      border-color: #DADCE2
      &:hover
        color: rgba(250, 122, 80, 1)
        border-color: rgba(250, 122, 80, 1)
    .ivu-btn-primary
      background: rgba(250, 122, 80, 1)
      border-color: rgba(250, 122, 80, 1)
      &:hover
        background: #FC9C7C
        border-color: #FC9C7C
.attention_content_title
  commonBgColor(#2A2F42, #FFFAF5)
  font-size: 18px
  commonColor(#E9E9EB, #333333)
  line-height: 50px
  font-weight: 600
  padding-left: 30px
.attention_content_nav
  padding: 0 30px
  commonBgColor(#1f2330, #FFFFFF)
.how_att
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background: rgba(0,0,0,.7);
  z-index: 1002;
  .how_att_info
    width: 500px;
    height: 384px;
    position: absolute;
    transform: translate(-50%,-50%);
    top: 50%;
    left: 50%;
    background: #fff;
    position: relative;
    .one
      width: 500px;
      height: 340px;
      overflow-x: hidden;
      display: flex;
      img
        flex: 0 0 500px;
        height: 340px;
        display: block;
        transition: all .3s;
      img:nth-child(2).on
        transform: translateX(-500px)
      img:nth-child(3).on
        transform: translateX(-1000px)
    .two
      padding: 14px 28px;
      display: flex;
      justify-content: space-between;
      .dot
        display: flex;
        align-items: center;
        div
          width: 6px;
          height: 6px;
          border-radius: 50%;
          background:rgba(255,136,36,0.30);
        div+div
          margin-left: 8px
        div.on
          background: rgba(250, 122, 80, 1)
      p
        font-size: 14px;
        color: rgba(250, 122, 80, 1);
        cursor: pointer;
        &:hover
          color: #FC9C7C
    .iconfont
      font-size: 24px;
      position: absolute;
      top: 0;
      right: -40px;
      commonColor(#BCBDC1, #333333)
      cursor: pointer;
      &:hover
        color: #fff
</style>
